import React, { useState } from 'react'
import { Box, Typography, DialogActions, Tooltip } from '@mui/material'

import { useIntl } from 'react-intl'
import { ReactComponent as CancelIcon } from '../../../../../../resources/images/Delete.svg'
import { ReactComponent as ObservacionesIcon } from '../../../../../../resources/images/Comentari.svg'

import { ThemeButton, useModalContext, ConfirmationDialog } from '../../../../../../ui'
import { useCombos } from '../../../../../combos'
import { PUBLICOFFER_STATES } from '../../constants'
import { ObservacionesDialog } from './observacion.dialog'
import { feedback } from '../../../../../../core/feedback'

export const ResumePublicOfferDialog = ({
  po,
  publicOfferData,
  cancelOp,
  addObservaciones,
  forceRefresh,
  setForceRefresh,
  setOpenResume,
}) => {
  const { formatMessage, formatDate } = useIntl()
  const combos = useCombos(['estados_peticion_op'])
  const [ops, setOps] = useState(po)
  const {
    actions: { open },
  } = useModalContext()

  const handleCancelApp = (poId, estadoOp, currentEstado) => {
    currentEstado === PUBLICOFFER_STATES.REJECTED.KEY ||
    currentEstado === PUBLICOFFER_STATES.OUTRANGED.KEY ||
    currentEstado === PUBLICOFFER_STATES.ANULED.KEY
      ? feedback('error', 'Esta solicitud ya ha sido rechazada con anterioridad')
      : open({
          Component: ConfirmationDialog,
          data: {
            title: formatMessage({
              id: 'pages.profile.company.guild.info.publicOffer.reject.title',
            }),
            text: formatMessage({
              id: 'pages.profile.company.guild.info.publicOffer.reject.description',
            }),
            yesText: formatMessage({
              id: 'pages.application.view.documentRequestAssociation.yes',
            }),
            noText: formatMessage({ id: 'pages.application.view.documentRequestAssociation.no' }),
            yesAction: async () => {
              await cancelOp(poId, estadoOp, publicOfferData, setOps, ops)
              setForceRefresh(!forceRefresh)
            },
          },
          type: 'centered',
        })
  }

  const handleOpenDialog = (id, poObservacionesInstalador) => {
    open({
      Component: ObservacionesDialog,
      data: {
        AdhesionId: id,
        addObservaciones,
        publicOfferData,
        poObservacionesInstalador: poObservacionesInstalador,
      },
      type: 'centered',
      maxWidth: 'md',
    })
  }

  const handleAceptar = () => {
    setForceRefresh(!forceRefresh)
    setOpenResume(false)
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      p={2}
      height="90vh"
      overflow="none"
      minWidth="80em"
    >
      <Box m={2} flexDirection="column" position={'relative'}>
        <Box>
          <Typography variant="h6" color="primary">
            {formatMessage({
              id: 'pages.profile.company.guild.info.publicOffer.resume.title',
            })}
          </Typography>
        </Box>

        <Box
          mt={2}
          display="flex"
          alignItems="center"
          sx={{
            borderBottom: '2px solid #e0e0e0',
            pb: 1,
          }}
        >
          <Box sx={{ width: '20%', minWidth: '150px', pr: 2 }}>
            <Typography sx={{ fontWeight: 'bold' }}>
              {formatMessage({
                id: 'pages.profile.company.guild.publicOffer.info.name.title',
              })}
            </Typography>
          </Box>

          <Box sx={{ width: '15%', minWidth: '120px', pr: 2 }}>
            <Typography sx={{ fontWeight: 'bold' }}>
              {formatMessage({
                id: 'pages.profile.company.guild.publicOffer.info.status.title',
              })}
            </Typography>
          </Box>

          <Box sx={{ width: '35%', minWidth: '200px', pr: 2 }}>
            <Typography sx={{ fontWeight: 'bold' }}>
              {formatMessage({
                id: 'pages.application.detail.panels.2.fields.observaciones.label',
              })}
            </Typography>
          </Box>

          <Box sx={{ width: '15%', minWidth: '100px', pr: 2 }}>
            <Typography sx={{ fontWeight: 'bold' }}>
              {formatMessage({
                id: 'pages.profile.company.guild.publicOffer.info.hasta.title',
              })}
            </Typography>
          </Box>

          <Box sx={{ width: '15%', minWidth: '100px', textAlign: 'center' }}>
            <Typography sx={{ fontWeight: 'bold' }}>
              {formatMessage({
                id: 'global.actions',
              })}
            </Typography>
          </Box>
        </Box>

        <Box
          flexDirection="column"
          display="flex"
          overflow="auto"
          maxHeight="calc(90vh - 200px)"
          sx={{ mt: 1 }}
        >
          {po
            ?.sort((a, b) => new Date(b.dg_ts_insert) - new Date(a.dg_ts_insert))
            .map((pa, i) => {
              return pa.estado !== PUBLICOFFER_STATES.OUTRANGED.KEY ? (
                <Box
                  key={i}
                  display="flex"
                  alignItems="center"
                  sx={{
                    py: 1.5,
                    borderBottom: '1px solid #f0f0f0',
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }}
                >
                  <Box sx={{ width: '20%', minWidth: '150px', pr: 2 }}>
                    <Tooltip title={pa.nombre} placement="top">
                      <Typography
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          display: 'block',
                        }}
                      >
                        {pa.nombre}
                      </Typography>
                    </Tooltip>
                  </Box>

                  <Box sx={{ width: '15%', minWidth: '120px', pr: 2 }}>
                    <Typography
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {combos.estados_peticion_op.data.map((combo) => {
                        return combo.key === pa.estado ? combo.value : null
                      })}
                    </Typography>
                  </Box>

                  <Box sx={{ width: '35%', minWidth: '200px', pr: 2 }}>
                    <Typography
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {PUBLICOFFER_STATES.REJECTED.KEY === pa.estado
                        ? pa.observaciones_rechazo
                          ? pa.observaciones_rechazo
                          : 'Rechazado por instalador'
                        : PUBLICOFFER_STATES.ANULED.KEY === pa.estado
                          ? pa.observaciones_anulacion
                          : null}
                    </Typography>
                  </Box>

                  <Box sx={{ width: '15%', minWidth: '100px', pr: 2 }}>
                    <Typography>{formatDate(pa.fechafin)}</Typography>
                  </Box>

                  <Box
                    sx={{
                      width: '15%',
                      minWidth: '100px',
                      display: 'flex',
                      justifyContent: 'center',
                      gap: 2,
                    }}
                  >
                    <Tooltip title="Observaciones">
                      <ObservacionesIcon
                        style={{
                          color: '#004a6b',
                          cursor: 'pointer',
                          maxWidth: '20px',
                          maxHeight: '20px',
                        }}
                        onClick={() =>
                          handleOpenDialog(pa.adhesion_id, pa.observaciones_instalador)
                        }
                      />
                    </Tooltip>

                    <Tooltip title="Rechazar Adhesión">
                      <CancelIcon
                        style={{
                          color: '#004a6b',
                          cursor: 'pointer',
                          maxWidth: '20px',
                          maxHeight: '20px',
                        }}
                        onClick={() =>
                          handleCancelApp(
                            pa.adhesion_id,
                            PUBLICOFFER_STATES.REJECTED.KEY,
                            pa.estado
                          )
                        }
                      />
                    </Tooltip>
                  </Box>
                </Box>
              ) : null
            })}
        </Box>
      </Box>
      <DialogActions>
        <Box alignSelf="flex-end" display="flex" justifyContent="flex-end" right={20} bottom={20}>
          <Box display="flex">
            <ThemeButton color="primary" labelM="lg" onClick={handleAceptar}>
              {formatMessage({ id: 'global.close' })}
            </ThemeButton>
          </Box>
        </Box>
      </DialogActions>
    </Box>
  )
}
